module.exports = __webpack_public_path__ + "img/receipt.701ed8dc.svg";